export interface HeaderAgentWorkbenchDto {
  businessDate: string;
  agentName: string;
  creditorId: string;
  creditorLabel: string;
  totalAssignedCases: number;
  totalCasesToProcess: number;
  portfolioOverdueAmount: number;
}

export interface AgentCaseItemDto {
  caseId: string;
  caseReference: string;
  customerName: string;
  contractReference: string;
  overdueAmount: number;
  daysLate: number;
  categoryAgeDays: number;
  lastActionLabel: string;
  mainPhone: string;
  status: string;
  priority: string;
}

export interface ActionCategoryDto {
  categoryCode: string;
  categoryLabel: string;
  caseCount: number;
  totalAmount: number;
  oldestAgeDays: number;
  cases: AgentCaseItemDto[];
}

/** Ordre fonctionnel des catégories MVP défini par le SFD (§4.1). */
export const AGENT_MVP_CATEGORY_ORDER = [
  'NEW_CLIENT',
  'BROKEN_PROMISE',
  'TODAY_DUE',
  'PHONE_REMINDER',
  'UNREACHABLE',
  'SEND_SMS',
  'REMINDER_LETTER',
  'NEGOTIATION_DOCUMENT',
] as const;

/**
 * CA-AGT-03 — tri métier commun : ancienneté dans la catégorie décroissante,
 * puis montant impayé décroissant. L'identifiant stabilise les égalités.
 */
export function compareAgentCases(a: AgentCaseItemDto, b: AgentCaseItemDto): number {
  return (
    b.categoryAgeDays - a.categoryAgeDays ||
    b.overdueAmount - a.overdueAmount ||
    a.caseId.localeCompare(b.caseId)
  );
}
